import React, { useEffect, useState } from "react";
import InvoiceRemarak from "../common/InvoiceRemark";
import InvoiceRemark from "../common/InvoiceRemark";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { fetchInvoiceUniqueData, invoiceDocumentskData, invoiceRemarkData, } from "../../features/invoicesSlice/invoicesSlice";
import { formatDate, formatDateTime } from "../../utils/dateUtils";
import { formatNumber } from "../../utils/formatNumber";
const uploadUrl = process.env.REACT_APP_BACKEND_UPLOADS;

const InfFinDetails = () => {

    const dispatch = useDispatch();
    const location = useLocation();
    const navigate = useNavigate();
    const [videoData, setVideoData] = useState([]);

    const [showRemark, setShowRemark] = useState(false)
    const selectedData = location.state;

    console.log("selectedData ==>", selectedData);

    const { invoiceDataDetails, invoiceRemarkDetails, invoiceDocumentsDetails, invoicePaymentData, status, message } = useSelector(
        (state) => state.invoiceFinance
    );

    useEffect(() => {
        if (selectedData?.id) {
            const payload = {
                video_id: selectedData?.id
            };
            dispatch(fetchInvoiceUniqueData(payload))
            dispatch(invoiceRemarkData(payload))
            dispatch(invoiceDocumentskData(payload))
        }
    }, [dispatch, selectedData])

    useEffect(() => {
        setVideoData(invoiceDataDetails)

    }, [invoiceDataDetails])


    const handleRemark = () => {
        setShowRemark(true)
    }
    return (<>

        <div className="profile-foreground position-relative mx-n4 mt-n4">
            <div className="profile-wid-bg">
                <img src="../assets/images/profile-bg.jpg" alt="" className="profile-wid-img" />
            </div>
        </div>
        <div className="pt-4 mb-4 mb-lg-3 pb-lg-4 profile-wrapper">
            <div className="row g-4">
                <div className="col-auto">
                    <div className="avatar-lg">
                        <img src="../assets/images/channels4_profile.jpg  " alt="user-img" className="img-thumbnail" />
                    </div>
                </div>
                <div className="col">
                    <div className="p-2">
                        <h3 className="text-white mb-1">Invest Today</h3>
                        <p className="text-white text-opacity-75">
                            <div className="badge rounded-pill bg-success fs-12">Active</div>
                        </p>
                        <div className="hstack text-white-50 gap-1">
                            <div className="me-2 hstack gap-3 flex-wrap">
                                <div>Created Date: <span className="fw-medium">25 Dec, 2024
                                </span></div>
                            </div>
                            <div className="me-2">
                                <div>Onboarded Date: <span className="fw-medium">25 Dec, 2024</span></div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </div>

        <div className="row">
            <div className="col-lg-12">
                <div>
                    <div className="d-flex profile-wrapper">
                        <ul className="nav nav-pills animation-nav profile-nav gap-2 gap-lg-3 flex-grow-1" role="tablist">
                            <li className="nav-item">
                                <a className="nav-link fs-14 active" data-bs-toggle="tab" href="#overview-tab" role="tab">
                                    <i className="ri-airplay-fill d-inline-block d-md-none"></i> <span
                                        className="d-none d-md-inline-block">Overview</span>
                                </a>
                            </li>

                        </ul>
                    </div>
                    <div className="tab-content pt-4 text-muted">
                        <div className="tab-pane active" id="overview-tab" role="tabpanel">
                            <div className="row">

                                <div className="col-xxl-12">
                                    <div className="card">
                                        <div className="card-body">

                                            <div className="row">
                                                <div className="col-6 col-md-4">
                                                    <div className="d-flex mt-4">
                                                        <div className="flex-shrink-0 avatar-xs align-self-center me-3">
                                                            <div className="avatar-title bg-light rounded-circle fs-16 text-primary">
                                                                <i className="ri-user-2-fill"></i>
                                                            </div>
                                                        </div>
                                                        <div className="flex-grow-1 overflow-hidden">
                                                            <p className="mb-1">Genre :</p>
                                                            <h6 className="text-truncate mb-0">Investment</h6>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-6 col-md-4">
                                                    <div className="d-flex mt-4">
                                                        <div className="flex-shrink-0 avatar-xs align-self-center me-3">
                                                            <div className="avatar-title bg-light rounded-circle fs-16 text-primary">
                                                                <i className="ri-global-line"></i>
                                                            </div>
                                                        </div>
                                                        <div className="flex-grow-1 overflow-hidden">
                                                            <p className="mb-1">Language :</p>
                                                            <h6 className="text-truncate mb-0">Hindi</h6>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-6 col-md-4">
                                                    <div className="d-flex mt-4">
                                                        <div className="flex-shrink-0 avatar-xs align-self-center me-3">
                                                            <div className="avatar-title bg-light rounded-circle fs-16 text-primary">
                                                                <i className="ri-user-2-fill"></i>
                                                            </div>
                                                        </div>
                                                        <div className="flex-grow-1 overflow-hidden">
                                                            <p className="mb-1">Video Live Status :</p>
                                                            <h6 className="text-truncate mb-0">Working</h6>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-6 col-md-4">
                                                    <div className="d-flex mt-4">
                                                        <div className="flex-shrink-0 avatar-xs align-self-center me-3">
                                                            <div className="avatar-title bg-light rounded-circle fs-16 text-primary">
                                                                <i className="ri-global-line"></i>
                                                            </div>
                                                        </div>
                                                        <div className="flex-grow-1 overflow-hidden">
                                                            <p className="mb-1">Contact Person Name :</p>
                                                            <h6 className="text-truncate mb-0">Bhargav</h6>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-6 col-md-4">
                                                    <div className="d-flex mt-4">
                                                        <div className="flex-shrink-0 avatar-xs align-self-center me-3">
                                                            <div className="avatar-title bg-light rounded-circle fs-16 text-primary">
                                                                <i className="ri-user-2-fill"></i>
                                                            </div>
                                                        </div>
                                                        <div className="flex-grow-1 overflow-hidden">
                                                            <p className="mb-1">Email id :</p>
                                                            <h6 className="text-truncate mb-0">investtoday.contactus@gmail.com</h6>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-6 col-md-4">
                                                    <div className="d-flex mt-4">
                                                        <div className="flex-shrink-0 avatar-xs align-self-center me-3">
                                                            <div className="avatar-title bg-light rounded-circle fs-16 text-primary">
                                                                <i className="ri-global-line"></i>
                                                            </div>
                                                        </div>
                                                        <div className="flex-grow-1 overflow-hidden">
                                                            <p className="mb-1">Phone no :</p>
                                                            <h6 className="text-truncate mb-0">8424060780</h6>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-6 col-md-4">
                                                    <div className="d-flex mt-4">
                                                        <div className="flex-shrink-0 avatar-xs align-self-center me-3">
                                                            <div className="avatar-title bg-light rounded-circle fs-16 text-primary">
                                                                <i className="ri-user-2-fill"></i>
                                                            </div>
                                                        </div>
                                                        <div className="flex-grow-1 overflow-hidden">
                                                            <p className="mb-1">Dedicated Video Cost :</p>
                                                            <h6 className="text-truncate mb-0">1L</h6>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-6 col-md-4">
                                                    <div className="d-flex mt-4">
                                                        <div className="flex-shrink-0 avatar-xs align-self-center me-3">
                                                            <div className="avatar-title bg-light rounded-circle fs-16 text-primary">
                                                                <i className="ri-global-line"></i>
                                                            </div>
                                                        </div>
                                                        <div className="flex-grow-1 overflow-hidden">
                                                            <p className="mb-1">Negotiated Video Cost :</p>
                                                            <h6 className="text-truncate mb-0">80k</h6>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-6 col-md-4">
                                                    <div className="d-flex mt-4">
                                                        <div className="flex-shrink-0 avatar-xs align-self-center me-3">
                                                            <div className="avatar-title bg-light rounded-circle fs-16 text-primary">
                                                                <i className="ri-user-2-fill"></i>
                                                            </div>
                                                        </div>
                                                        <div className="flex-grow-1 overflow-hidden">
                                                            <p className="mb-1">Integrated Video Cost :</p>
                                                            <h6 className="text-truncate mb-0">50k</h6>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-6 col-md-4">
                                                    <div className="d-flex mt-4">
                                                        <div className="flex-shrink-0 avatar-xs align-self-center me-3">
                                                            <div className="avatar-title bg-light rounded-circle fs-16 text-primary">
                                                                <i className="ri-global-line"></i>
                                                            </div>
                                                        </div>
                                                        <div className="flex-grow-1 overflow-hidden">
                                                            <p className="mb-1">Negotiated Integrated Video Cost :</p>
                                                            <h6 className="text-truncate mb-0">30k</h6>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="row">
                                        <div className="col-lg-12">
                                            <div className="card">
                                                <div className="card-header align-items-center d-flex">
                                                    <h4 className="card-title mb-0  me-2">Channels</h4>
                                                </div>
                                                <div className="card-body">

                                                    <div className="border-top border-top-dashed">
                                                        <div className="row gy-3">
                                                            <div className="table-responsive">
                                                                <table className="table align-middle mb-0">
                                                                    <thead className="table-light">
                                                                        <tr>
                                                                            <th scope="col">Channel</th>
                                                                            <th scope="col">Channel Links</th>
                                                                            <th scope="col">Subscribers/Followers</th>
                                                                            <th scope="col">Avg. Views</th>
                                                                            <th scope="col">Cost</th>
                                                                        </tr>
                                                                    </thead>
                                                                    <tbody>
                                                                        <tr>
                                                                            <td>Youtube</td>
                                                                            <td><a href="https://www.youtube.com/@InvestToday" target="_blank"
                                                                                className="fw-semibold">https://www.youtube.com/@InvestToday</a></td>

                                                                            <td>4.8k</td>
                                                                            <td>500k</td>
                                                                            <td>
                                                                                <button className="btn btn-sm btn-info edit-item-btn" data-bs-toggle="modal"
                                                                                    data-bs-target="#viewCost"><i
                                                                                        className="ri-eye-fill align-bottom"></i>View</button>
                                                                            </td>
                                                                        </tr>
                                                                        <tr>
                                                                            <td>Instagram</td>
                                                                            <td><a href="https://www.Instagram.com/@InvestToday" target="_blank"
                                                                                className="fw-semibold">https://www.Instagram.com/@InvestToday</a></td>

                                                                            <td>4.8k</td>
                                                                            <td>500k</td>

                                                                            <td>
                                                                                <button className="btn btn-sm btn-info edit-item-btn" data-bs-toggle="modal"
                                                                                    data-bs-target="#viewCost"><i
                                                                                        className="ri-eye-fill align-bottom"></i>View</button>
                                                                            </td>

                                                                        </tr>
                                                                    </tbody>
                                                                </table>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="row">
                                        <div className="col-lg-12">
                                            <div className="card">
                                                <div className="card-header align-items-center d-flex">
                                                    <h4 className="card-title mb-0  me-2">Total Amount Paid</h4>
                                                </div>
                                                <div className="card-body">

                                                    <div className="border-top border-top-dashed">
                                                        <div className="row gy-3">
                                                            <div className="table-responsive">
                                                                <table className="table align-middle mb-0">
                                                                    <thead className="table-light">
                                                                        <tr>
                                                                            <th scope="col">Channel</th>
                                                                            <th scope="col">Video Type</th>
                                                                            <th scope="col">Video ID</th>
                                                                            <th scope="col">Video Live Date</th>
                                                                            <th scope="col">Closed Video Cost</th>
                                                                            <th scope="col">DM Name</th>
                                                                            <th scope="col">Client Name</th>
                                                                        </tr>
                                                                    </thead>
                                                                    <tbody>
                                                                        <tr>
                                                                            <td>Youtube</td>
                                                                            <td><a href="invoice-details.html" className="fw-semibold">VID001</a></td>

                                                                            <td>Dedicated</td>
                                                                            <td>20-11-2024</td>
                                                                            <td>1L</td>
                                                                            <td>
                                                                                DM1
                                                                            </td>
                                                                            <td>
                                                                                PolicyBazaar
                                                                            </td>
                                                                        </tr>
                                                                        <tr>
                                                                            <td>Instagram</td>
                                                                            <td><a href="invoice-details.html" className="fw-semibold">VID001</a></td>

                                                                            <td>-</td>
                                                                            <td>20-11-2024</td>
                                                                            <td>1L</td>
                                                                            <td>
                                                                                DM2
                                                                            </td>
                                                                            <td>
                                                                                PolicyChayan
                                                                            </td>
                                                                        </tr>
                                                                    </tbody>
                                                                </table>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="card">
                                        <div className="card-body">
                                            <h5 className="card-title">Scheduled Videos</h5>
                                            <div className="swiper project-swiper mt-n4">
                                                <div className="d-flex justify-content-end gap-2 mb-2">
                                                    <div className="slider-button-prev">
                                                        <div className="avatar-title fs-18 rounded px-1">
                                                            <i className="ri-arrow-left-s-line"></i>
                                                        </div>
                                                    </div>
                                                    <div className="slider-button-next">
                                                        <div className="avatar-title fs-18 rounded px-1">
                                                            <i className="ri-arrow-right-s-line"></i>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="swiper-wrapper">
                                                    <div className="swiper-slide">
                                                        <div className="card profile-project-card shadow-none profile-project-success mb-0">
                                                            <div className="card-body p-4">
                                                                <div className="d-flex">
                                                                    <div className="flex-grow-1 text-muted overflow-hidden">
                                                                        <h5 className="fs-14 text-truncate mb-1">
                                                                            <a href="#" className="text-body">Health Insurance Video</a>
                                                                        </h5>
                                                                        <p className="text-muted text-truncate mb-0"> Last Update : <span
                                                                            className="fw-semibold text-body">4 hr Ago</span></p>
                                                                    </div>
                                                                    <div className="flex-shrink-0 ms-2">
                                                                        <div className="badge bg-warning-subtle text-warning fs-10"> In progress</div>
                                                                    </div>
                                                                </div>
                                                                <div className="d-flex mt-4">
                                                                    <div className="flex-grow-1">
                                                                        <div className="d-flex align-items-center gap-2">
                                                                            <div>
                                                                                <h5 className="fs-12 text-muted mb-0"> Client :</h5>
                                                                            </div>
                                                                            PolicyChayan
                                                                        </div>
                                                                        <div className="d-flex align-items-center gap-2">
                                                                            <div>
                                                                                <h5 className="fs-12 text-muted mb-0"> Video id :</h5>
                                                                            </div>
                                                                            <a href="#">ABCDEF123GHII</a>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="swiper-slide">
                                                        <div className="card profile-project-card shadow-none profile-project-danger mb-0">
                                                            <div className="card-body p-4">
                                                                <div className="d-flex">
                                                                    <div className="flex-grow-1 text-muted overflow-hidden">
                                                                        <h5 className="fs-14 text-truncate mb-1">
                                                                            <a href="#" className="text-body">Term Insurance</a>
                                                                        </h5>
                                                                        <p className="text-muted text-truncate mb-0"> Last Update : <span
                                                                            className="fw-semibold text-body">1 hr Ago</span></p>
                                                                    </div>
                                                                    <div className="flex-shrink-0 ms-2">
                                                                        <div className="badge bg-success-subtle text-success fs-10"> Completed</div>
                                                                    </div>
                                                                </div>
                                                                <div className="d-flex mt-4">
                                                                    <div className="flex-grow-1">
                                                                        <div className="d-flex align-items-center gap-2">
                                                                            <div>
                                                                                <h5 className="fs-12 text-muted mb-0"> Client :</h5>
                                                                            </div>
                                                                            Policy Bazaar
                                                                        </div>
                                                                        <div className="d-flex align-items-center gap-2">
                                                                            <div>
                                                                                <h5 className="fs-12 text-muted mb-0"> Video id :</h5>
                                                                            </div>
                                                                            <a href="#">ABCDEF123GHII</a>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="swiper-slide">
                                                        <div className="card profile-project-card shadow-none profile-project-info mb-0">
                                                            <div className="card-body p-4">
                                                                <div className="d-flex">
                                                                    <div className="flex-grow-1 text-muted overflow-hidden">
                                                                        <h5 className="fs-14 text-truncate mb-1">
                                                                            <a href="#" className="text-body">Brand logo Design</a>
                                                                        </h5>
                                                                        <p className="text-muted text-truncate mb-0">Last Update : <span
                                                                            className="fw-semibold text-body">2 hr Ago</span></p>
                                                                    </div>
                                                                    <div className="flex-shrink-0 ms-2">
                                                                        <div className="badge bg-warning-subtle text-warning fs-10"> In progress</div>
                                                                    </div>
                                                                </div>
                                                                <div className="d-flex mt-4">
                                                                    <div className="flex-grow-1">
                                                                        <div className="d-flex align-items-center gap-2">
                                                                            <div>
                                                                                <h5 className="fs-12 text-muted mb-0"> Client :</h5>
                                                                            </div>
                                                                            GeoAdsMedia
                                                                        </div>
                                                                        <div className="d-flex align-items-center gap-2">
                                                                            <div>
                                                                                <h5 className="fs-12 text-muted mb-0"> Video id :</h5>
                                                                            </div>
                                                                            <a href="#">ABCDEF123GHII</a>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="swiper-slide">
                                                        <div className="card profile-project-card shadow-none profile-project-danger mb-0">
                                                            <div className="card-body p-4">
                                                                <div className="d-flex">
                                                                    <div className="flex-grow-1 text-muted overflow-hidden">
                                                                        <h5 className="fs-14 text-truncate mb-1">
                                                                            <a href="#" className="text-body">Digital Marketing</a>
                                                                        </h5>
                                                                        <p className="text-muted text-truncate mb-0"> Last Update : <span
                                                                            className="fw-semibold text-body">4 hr Ago</span></p>
                                                                    </div>
                                                                    <div className="flex-shrink-0 ms-2">
                                                                        <div className="badge bg-success-subtle text-success fs-10"> Completed</div>
                                                                    </div>
                                                                </div>

                                                                <div className="d-flex mt-4">
                                                                    <div className="flex-grow-1">
                                                                        <div className="d-flex align-items-center gap-2">
                                                                            <div>
                                                                                <h5 className="fs-12 text-muted mb-0"> Client :</h5>
                                                                            </div>
                                                                            GeoAdsMedia
                                                                        </div>
                                                                        <div className="d-flex align-items-center gap-2">
                                                                            <div>
                                                                                <h5 className="fs-12 text-muted mb-0"> Video id :</h5>
                                                                            </div>
                                                                            <a href="#">ABCDEF123GHII</a>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="swiper-slide">
                                                        <div className="card profile-project-card shadow-none profile-project-warning mb-0">
                                                            <div className="card-body p-4">
                                                                <div className="d-flex">
                                                                    <div className="flex-grow-1 text-muted overflow-hidden">
                                                                        <h5 className="fs-14 text-truncate mb-1">
                                                                            <a href="#" className="text-body">Chat App</a>
                                                                        </h5>
                                                                        <p className="text-muted text-truncate mb-0"> Last Update : <span
                                                                            className="fw-semibold text-body">1 hr Ago</span></p>
                                                                    </div>
                                                                    <div className="flex-shrink-0 ms-2">
                                                                        <div className="badge bg-warning-subtle text-warning fs-10"> Inprogress</div>
                                                                    </div>
                                                                </div>

                                                                <div className="d-flex mt-4">
                                                                    <div className="flex-grow-1">
                                                                        <div className="d-flex align-items-center gap-2">
                                                                            <div>
                                                                                <h5 className="fs-12 text-muted mb-0"> Client :</h5>
                                                                            </div>
                                                                            GeoAdsMedia
                                                                        </div>
                                                                        <div className="d-flex align-items-center gap-2">
                                                                            <div>
                                                                                <h5 className="fs-12 text-muted mb-0"> Video id :</h5>
                                                                            </div>
                                                                            <a href="#">ABCDEF123GHII</a>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                            </div>

                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </>)
};

export default InfFinDetails;
